<template>
  <!-- wrapper(s) -->
  <div class="wrapper">
    <Header class="header" :val="headerTitle"></Header>
    <div class="container">
      <!-- content(s) -->
      <div id="content">
        <section class="hr pt25 mb25">
          <div class="formArea mt0">
            <select class="ipt" id="agency_1" title="상품 선택" v-model="applyOrderId">
              <option value="" selected="selected">선택</option>
              <option v-for="(serviceAuthDocument, index) in serviceAuthDocumentList" :key="index" :value="serviceAuthDocument.orderId">
                {{ serviceAuthDocument.orderId }} / {{ serviceAuthDocument.productName }}
              </option>
            </select>
            <div class="setBtnS">
              <select class="ipt" id="agency_2" title="증빙서류 선택" v-model="dcmnCd">
                <option v-for="(dctpCode, index) in dctpCodeList" :value="dctpCode.code" :key="index">{{ dctpCode.codeName }}</option>
              </select>
              <button type="button" class="btn_g m" @click="apply()">신청</button>
            </div>
          </div>
        </section>
        <section class="hr">
          <div class="titArea">
            <h2 class="titH4">증빙서류 신청내역</h2>
          </div>
          <table class="tableX noLine" v-if="serviceAuthDocumentByOrderIdList.length > 0">
            <caption>신청일자, 서류유형, 열람에 대한 내용입니다.</caption>
            <colgroup>
              <col style="width: 30%" />
              <col style="width: auto" />
              <col style="width: 20%" />
            </colgroup>
            <thead>
              <tr>
                <th>신청일자</th>
                <th>서류유형</th>
                <th>열람</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(serviceAuthDocumentByOrderId, index) in serviceAuthDocumentByOrderIdList" :key="index">
                <td>{{ serviceAuthDocumentByOrderId.reqDtStr }}</td>
                <td>{{ serviceAuthDocumentByOrderId.dcmnCdNm }}</td>
                <td>
                  <button
                    type="button"
                    class="btn_s s"
                    @click="btnShowPop(serviceAuthDocumentByOrderId.dcmnCd, serviceAuthDocumentByOrderId.orderId)"
                  >
                    열람
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <!--신청내역 없을 경우(s)-->
          <div class="resultMsg txtOnly" v-else>
            <p class="copy">신청 내역이 없습니다.</p>
          </div>
          <!--신청내역 없을 경우(e)-->
        </section>

        <CommonBanner></CommonBanner>
      </div>
      <!-- content(e) -->
      <QuickMenu></QuickMenu>
    </div>
    <!-- container(e) -->
    <footer class="footer"></footer>

    <!-- 렌탈료 선납확인서 popup (s) -->
    <div class="popWrap nowOpen" v-if="prepaymentPop">
      <div class="popup">
        <div class="popContain">
          <div class="popCont full">
            <div class="popHead">
              <h1 class="titH1">렌탈료 선납확인서</h1>
            </div>
            <div class="popBody full">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section>
                  <table class="tableY">
                    <colgroup>
                      <col style="width: 110px" />
                      <col style="width: auto" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>고객명</th>
                        <td>{{ prepaymentInfo.info.customerName }}</td>
                      </tr>
                      <tr>
                        <th>계약번호</th>
                        <td>{{ prepaymentInfo.info.orderId }}</td>
                      </tr>
                      <tr>
                        <th>제품명</th>
                        <td>{{ prepaymentInfo.info.productName }}</td>
                      </tr>
                      <tr>
                        <th>설치일</th>
                        <td>{{ prepaymentInfo.info.releaseDateStr.substring(0, 10) }}</td>
                      </tr>
                      <tr>
                        <th>약정만료일</th>
                        <td>{{ prepaymentInfo.info.ownershipDate.substring(0, 10) }}</td>
                      </tr>
                      <tr>
                        <th>설치주소</th>
                        <td>{{ prepaymentInfo.info.addrRoad }} {{ prepaymentInfo.info.addrRemark }}</td>
                      </tr>
                      <tr>
                        <th>조회기간</th>
                        <td>{{ prepaymentInfo.info.dateFrom | dateFormatter('-') }} ~ {{ prepaymentInfo.info.dateTo | dateFormatter('-') }}</td>
                      </tr>
                    </tbody>
                  </table>
                </section>
                <section>
                  <div class="jqScroll rentalPay">
                    <div class="scroll">
                      <table class="tableX noLine tableBtype">
                        <caption>번호, 청구일, 청구회차, 청구금액, 입금금액, 입금일자, 선결제금액, 할인금액, 미납금액에 대한 내용입니다.</caption>
                        <colgroup>
                          <col style="width: 60px" />
                          <col style="width: auto" span="8" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>NO</th>
                            <th>청구일</th>
                            <th>청구금액</th>
                            <th>입금금액</th>
                            <th>입금일자</th>
                            <th>선납금액</th>
                            <th>할인금액</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(prepaymentInfoList, index) in prepaymentInfo.list" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ prepaymentInfoList.demandDate | dateFormatter('-') }}</td>
                            <td>{{ prepaymentInfoList.demandAmount | currency }}원</td>
                            <td>{{ prepaymentInfoList.depositAmount | currency }}원</td>
                            <td>{{ prepaymentInfoList.rcptDtDtm | dateFormatter('-') }}</td>
                            <td>{{ prepaymentInfoList.promotionAmount | currency }}원</td>
                            <td>{{ prepaymentInfoList.discountAmount | currency }}원</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>계</td>
                            <td>-</td>
                            <td>{{ getTotalPrice(prepaymentInfo.list, 'demandAmount') | currency }}원</td>
                            <td>{{ getTotalPrice(prepaymentInfo.list, 'depositAmount') | currency }}원</td>
                            <td>-</td>
                            <td>{{ getTotalPrice(prepaymentInfo.list, 'promotionAmount') | currency }}원</td>
                            <td>{{ getTotalPrice(prepaymentInfo.list, 'discountAmount') | currency }}원</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <ul class="txtList_remark">
                    <li>위와 같이 납부하였음을 확인함</li>
                  </ul>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>

            <!-- <div class="shareBtn">
              <a href="#link" class="icoBtn share">
                <span><span class="blind">공유하기</span></span>
              </a>
            </div> -->
            <button type="button" class="btnIco_close" @click="prepaymentPop = false"><span>팝업 닫기</span></button>
          </div>
        </div>
      </div>
    </div>
    <!-- 렌탈료 선납확인서 popup (e) -->

    <!-- 렌탈료 납부내역서 popup (s) -->
    <div class="popWrap nowOpen" v-if="paymentHistoryPop">
      <div class="popup">
        <div class="popContain">
          <div class="popCont full">
            <div class="popHead">
              <h1 class="titH1">렌탈료 납부내역서</h1>
            </div>
            <div class="popBody full">
              <div class="popInner">
                <!-- 본문 (s) -->
                <section>
                  <table class="tableY">
                    <colgroup>
                      <col style="width: 110px" />
                      <col style="width: auto" />
                    </colgroup>
                    <tbody>
                      <tr>
                        <th>고객명</th>
                        <td>{{ paymentHistoryInfo.info.customerName }}</td>
                      </tr>
                      <tr>
                        <th>계약번호</th>
                        <td>{{ paymentHistoryInfo.info.orderId }}</td>
                      </tr>
                      <tr>
                        <th>제품명</th>
                        <td>{{ paymentHistoryInfo.info.productName }}</td>
                      </tr>
                      <tr>
                        <th>설치일</th>
                        <td>{{ paymentHistoryInfo.info.releaseDateStr.substring(0, 10) }}</td>
                      </tr>
                      <tr>
                        <th>약정만료일</th>
                        <td>{{ paymentHistoryInfo.info.ownershipDate.substring(0, 10) }}</td>
                      </tr>
                      <tr>
                        <th>설치주소</th>
                        <td>{{ paymentHistoryInfo.info.addrRoad }} {{ paymentHistoryInfo.info.addrRemark }}</td>
                      </tr>
                      <tr>
                        <th>조회기간</th>
                        <td>
                          {{ paymentHistoryInfo.info.dateFrom | dateFormatter('-') }} ~ {{ paymentHistoryInfo.info.dateTo | dateFormatter('-') }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </section>
                <section>
                  <div class="jqScroll rentalPay">
                    <div class="scroll">
                      <table class="tableX noLine tableBtype">
                        <caption>번호, 청구일, 청구회차, 청구금액, 입금금액, 입금일자, 선결제금액, 할인금액, 미납금액에 대한 내용입니다.</caption>
                        <colgroup>
                          <col style="width: 60px" />
                          <col style="width: auto" span="8" />
                        </colgroup>
                        <thead>
                          <tr>
                            <th>NO</th>
                            <th>청구일</th>
                            <th>청구회차</th>
                            <th>청구금액</th>
                            <th>입금금액</th>
                            <th>입금일자</th>
                            <th>할인금액</th>
                            <th>미납금액</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="(paymentHistoryInfoList, index) in paymentHistoryInfo.list" :key="index">
                            <td>{{ index + 1 }}</td>
                            <td>{{ paymentHistoryInfoList.acppmtdat | dateFormatter('-') }}</td>
                            <td>{{ paymentHistoryInfoList.invoiceSeq }}</td>
                            <td>{{ paymentHistoryInfoList.demandAmount | currency }}원</td>
                            <td>{{ paymentHistoryInfoList.depositAmount | currency }}원</td>
                            <td>{{ paymentHistoryInfoList.rcptDtDtm | dateFormatter('-') }}</td>
                            <td>{{ paymentHistoryInfoList.discountAmount | currency }}원</td>
                            <td>{{ paymentHistoryInfoList.overdueAmount | currency }}원</td>
                          </tr>
                        </tbody>
                        <tfoot>
                          <tr>
                            <td>계</td>
                            <td>-</td>
                            <td></td>
                            <td>{{ getTotalPrice(paymentHistoryInfo.list, 'demandAmount') | currency }}원</td>
                            <td>{{ getTotalPrice(paymentHistoryInfo.list, 'depositAmount') | currency }}원</td>
                            <td>-</td>
                            <td>{{ getTotalPrice(paymentHistoryInfo.list, 'discountAmount') | currency }}원</td>
                            <td>{{ getTotalPrice(paymentHistoryInfo.list, 'overdueAmount') | currency }}원</td>
                          </tr>
                        </tfoot>
                      </table>
                    </div>
                  </div>
                  <ul class="txtList_remark">
                    <li>위와 같이 납부하였음을 확인함</li>
                  </ul>
                </section>
                <!-- 본문 (e) -->
              </div>
            </div>
            <!--
            <div class="shareBtn">
              <a href="#link" class="icoBtn share">
                <span><span class="blind">공유하기</span></span>
              </a>
            </div> -->
            <button type="button" class="btnIco_close" @click="paymentHistoryPop = false"><span>팝업 닫기</span></button>
          </div>
        </div>
      </div>
    </div>
    <!-- 렌탈료 납부내역서 popup (e) -->

    <MessagePop v-if="messagePop" @close="close">
      <p v-html="msg"></p>
    </MessagePop>
  </div>
  <!-- wrapper(e) -->
</template>

<script>
import * as customjs from '@/../static/js/m.front.js';
import ApiService from '@/common/api.service';
import QuickMenu from '@/views/app/comm/QuickMenu';
import MessagePop from '@/components/popup/MessagePop';
import CommonBanner from '@/components/banner/CommonBanner';
import { isEmpty } from '@/common/common.function';
import JwtService from '@/common/jwt.service';

export default {
  name: 'myVoucher',
  data: function () {
    console.log(this.$route.params);
    return {
      headerTitle: '증빙서류',
      messagePop: false,
      serviceAuthDocumentList: [],
      dctpCodeList: [],
      serviceAuthDocumentByOrderIdList: [],
      applyOrderId: this.$route.params.orderId,
      dcmnCd: 'DCTP0001',
      prepaymentPop: null,
      paymentHistoryPop: null,

      currentUser: JwtService.getUserInfo(),

      prepaymentInfo: {
        info: {
          customerName: '',
          orderId: '',
          productName: '',
          ownershipDate: '',
          releaseDateStr: '',
          addrRoad: '',
          addrRemark: '',
          dateFrom: '',
          dateTo: '',
        },
      },
      paymentHistoryInfo: {
        info: {
          customerName: '',
          orderId: '',
          productName: '',
          ownershipDate: '',
          releaseDateStr: '',
          addrRoad: '',
          addrRemark: '',
          dateFrom: '',
          dateTo: '',
        },
      },
    };
  },
  components: {
    QuickMenu,
    MessagePop,
    CommonBanner,
  },
  async mounted() {
    this.applyOrderId = this.$route.params.orderId;

    await this.selectServiceAuthDocument();
    this.selectCommonCodeList();
    if (!isEmpty(this.applyOrderId)) {
      this.selectServiceAuthDocumentByOrderId(this.applyOrderId);
    } else {
      this.applyOrderId = '';
    }
  },
  watch: {
    applyOrderId() {
      if (!isEmpty(this.applyOrderId)) {
        this.selectServiceAuthDocumentByOrderId(this.applyOrderId);
      } else {
        this.serviceAuthDocumentByOrderIdList = [];
      }
    },
  },
  methods: {
    selectServiceAuthDocument() {
      ApiService.service('GET', '/service/auth/document', '')
        .then(({ data }) => {
          console.log(data);
          this.serviceAuthDocumentList = data.result;
          // 메인화면에서 납부확인서/선납확인서 구분용
          if (this.$route.params.dcmnCd) this.dcmnCd = this.$route.params.dcmnCd;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectCommonCodeList() {
      ApiService.service('GET', '/common/code/DCTP', '')
        .then(({ data }) => {
          this.dctpCodeList = data.result[0].codeList;

          this.dcmnCd = this.dctpCodeList[0].code;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    selectServiceAuthDocumentByOrderId(orderId) {
      ApiService.service('GET', '/service/auth/document/' + orderId, '')
        .then(({ data }) => {
          this.serviceAuthDocumentByOrderIdList = data.result;
        })
        .catch(({ response }) => {
          console.log(response);
        });
    },
    apply() {
      let reqParam = {
        request: {
          dcmnCd: this.dcmnCd,
          orderId: this.applyOrderId,
          userId: this.currentUser.userId,
        },
        serviceType: 'app',
      };

      ApiService.service('POST', '/service/auth/document', reqParam)
        .then(({ data }) => {
          // console.log(data);
          if (data.isSucceed) {
            this.selectServiceAuthDocumentByOrderId(this.applyOrderId);
            this.msg = '신청 완료되었습니다.<br>증빙서류 신청내역에서 확인 가능합니다.';
            this.messagePop = true;
          } else {
            this.msg = data.error;
            this.messagePop = true;
          }
        })
        .catch(({ response }) => {
          console.log('error : ' + response);
        });
    },
    btnShowPop(dcmnCd, orderId) {
      let readingType = '';

      if (dcmnCd == 'DCTP0001') {
        this.prepaymentPop = true;
        readingType = 'EVDC0001';
      } else if (dcmnCd == 'DCTP0002') {
        this.paymentHistoryPop = true;
        readingType = 'EVDC0002';
      }

      ApiService.service('GET', '/service/auth/documentReading/' + orderId + '/' + readingType, '')
        .then(({ data }) => {
          if (data.isSucceed) {
            if (dcmnCd == 'DCTP0001') {
              this.prepaymentInfo = data.result;
            } else if (dcmnCd == 'DCTP0002') {
              this.paymentHistoryInfo = data.result;
            }
          }
        })
        .catch(({ response }) => {
          console.log(response);
        });

      setTimeout(function () {
        customjs.init();
      }, 100);
    },
    close() {
      this.messagePop = false;
    },
    getTotalPrice(list, flag) {
      let totDemandAmount = 0;
      let totDepositAmount = 0;
      let totPromotionAmount = 0;
      let totDiscountAmount = 0;
      let totOverdueAmount = 0;

      let result = 0;

      if (list != undefined && list.length > 0) {
        for (let obj of list) {
          totDemandAmount += Number(obj.demandAmount);
          totDepositAmount += Number(obj.depositAmount);
          totPromotionAmount += Number(obj.promotionAmount);
          totDiscountAmount += Number(obj.discountAmount);
          totOverdueAmount += Number(obj.overdueAmount);
        }

        if (flag == 'demandAmount') {
          result = totDemandAmount;
        } else if (flag == 'depositAmount') {
          result = totDepositAmount;
        } else if (flag == 'promotionAmount') {
          result = totPromotionAmount;
        } else if (flag == 'discountAmount') {
          result = totDiscountAmount;
        } else if (flag == 'overdueAmount') {
          result = totOverdueAmount;
        }
      }

      return result;
    },
  },
};
</script>
